import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer, Header } from '../Common';
import { SideBar } from '../Common/SideBar';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import Chat from '../../Models/Chat';
import axios from 'axios';
import {withTranslation} from "react-i18next";
import Common from "../../Models/Common";
class SystemChat extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            alert(this.props.t("LOGIN_ALERT"))
            // this.props.history.push('/login/seller');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        var url = decodeURIComponent(this.props.match.params.id).split('/')
        var seller_id = url[url.length - 1]
        var buyer_id = url[url.length - 2]
        console.log(seller_id)
        console.log(buyer_id)
        this.state = {
            conversation: [],
            other: [],
            content: '',
            seller: '',
            buyer: '',
            sender: '',
            receiver: '',
            user: logged_user.id,
            type: logged_user.user_type_id,
            userImage: logged_user.img_sidebar,
            attchmnt: null
        }
        this.getData();
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getData() {
        Chat.getConversationSys(this.state.user, 0).then(res => {
            this.setState({ conversation: res.data.payload })
            this.setState({ sender: this.state.user })
        })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    onChangePro(e) {
        this.setState({ attchmnt: e.target.files[0] })
    }

    handleSubmit(e) {
        document.getElementById("snd_msg").disabled = true;
        console.log(this.state)
        e.preventDefault();
        const formData = new FormData();
        formData.append('attchmnt', this.state.attchmnt)
        formData.append('seller', 0)
        formData.append('buyer', 0)
        formData.append('content', this.state.content)
        formData.append('sender', this.state.user)
        formData.append('receiver', 0)
        axios({
            method: 'post',
            url: Common.api + 'store-msg',
            // url: 'http://192.168.1.110/sharework_back_v2/public/backend/store-msg',
            // url: 'https://sharework-admin.bitpeboot.com/backend/update-basic-profile',
            data: formData,
            config: {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
        }).then(res => {
            if (res.data.status === 200) {
                alert(this.props.t('BUYER_ADMIN_MESSAGE.MESSAGE_SENT_ALERT'))
                window.location.reload()
            }
        })
    }

    messageList() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.type == 1) {
                return (
                    <div className="col-2 mt-5"  >
                        <Link to={'/buyer-direct-message-list'} className="text-right return_text mt-5 mb-3">
                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                        </Link>
                    </div>
                )
            } else if (this.state.type == 2) {
                return (
                    <div className="col-2 mt-5"  >
                        <Link to={'/seller-direct-message-list'} className="text-right return_text mt-5 mb-3">
                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                        </Link>
                    </div>
                )
            } else if (this.state.type == 3) {
                return (
                    <div className="col-2 mt-5"  >
                        <Link to={'/affiliator-direct-message-list'} className="text-right return_text mt-5 mb-3">
                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                        </Link>
                    </div>
                )
            }
        } else {
            if (this.state.type == 1) {
                return (
                    <div className="col-md-2" style={{ paddingLeft: '33px' }} >
                        <Link to={'/buyer-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                        </Link>
                    </div>
                )
            } else if (this.state.type == 2) {
                return (
                    <div className="col-md-2" style={{ paddingLeft: '33px' }} >
                        <Link to={'/seller-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                        </Link>
                    </div>
                )
            } else if (this.state.type == 3) {
                return (
                    <div className="col-md-2" style={{ paddingLeft: '33px' }} >
                        <Link to={'/affiliator-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                        </Link>
                    </div>
                )
            }
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8">
                                <div className=" row">
                                    <div className="col-10" style={{ paddingLeft: "22px" }}>
                                        <div className="mt-5  input_name big_font text-left" style={{ width: '100%', fontSize: '20px', textAlign: 'left' }}>
                                            {this.props.t('BUYER_ADMIN_MESSAGE.BUYER_ADMIN_MESSAGE_TITLE')}
                                        </div>
                                    </div>
                                    {this.messageList()}
                                </div>
                                <div className="m-2" style={{ height: "auto !important", border: "1px solid #e6e6e6" }}>

                                    {this.state.conversation.map(conv =>
                                        <div className="m-2">
                                            <div className="row">

                                                <div className="col-md-7 ">
                                                    <div className="message_name_text">
                                                        {(() => {
                                                            if (conv.first_name == null) {
                                                                return (
                                                                    <div className="">
                                                                        <span><b>{this.props.t('BUYER_ADMIN_MESSAGE.ADMINISTRATOR')}</b></span> <br />
                                                                    </div>
                                                                )
                                                            } else {
                                                                return (
                                                                    <div>
                                                                        <span><b>{conv.first_name}</b></span> <br />
                                                                    </div>
                                                                )
                                                            }
                                                        })()}
                                                        {/* {console.log(conv.first_name)} */}
                                                        {/* <span><b>{conv.first_name}</b></span><br /> */}
                                                    </div>
                                                    <div className="product_description">
                                                        {conv.content.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </div>
                                                    {(() => {
                                                        if (conv.file !== '') {
                                                            return (
                                                                <div style={{ fontSize: "13px" }}>
                                                                    <a href={conv.attchmnt} target="_blank">{conv.file}</a>
                                                                </div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div></div>
                                                            )
                                                        }
                                                    })()}
                                                    <div className="message_open_time">
                                                        &nbsp;
                                                    </div>
                                                </div>
                                                <div className="col-md-3 message_time">
                                                    {(JSON.stringify(conv.created_at)).substring(1, 11)}
                                                </div>
                                            </div>
                                            <hr />
                                        </div>
                                    )}
                                    <div className="m-2">
                                        <div className="row">
                                            {/* <div className="col-md-2 mini_pad m-2">
                                                <img src={this.state.userImage} className=" rounded-circle" alt="" width="100" height="100" /><br />
                                            </div> */}
                                            <div className="col-md-10" style={{ borderRadius: "0px" }}>
                                                <div className="row row_edit" >
                                                    <div className="col-md-3 message text-left" >
                                                        <span className=""><b>{this.props.t('BUYER_ADMIN_MESSAGE.MESSAGE_TITLE')}</b></span><br />
                                                    </div>
                                                    {/* <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>
                                                    </div> */}
                                                </div>
                                                <div className="message_form" style={{ borderRadius: "0px", padding: "2%" }}>
                                                    <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                        value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                    </textarea>
                                                    <input style={{ fontSize: "13px", paddingLeft: '10px' }} type="file" onChange={this.onChangePro.bind(this)}></input>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center p-3 " >
                                            <button id="snd_msg" onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                <span className="fa fa-check"></span>
                                                {this.props.t('BUYER_ADMIN_MESSAGE.SUBMIT_BTN')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //For Desktop View
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    {(() => {
                                        if (this.state.type == 1) {
                                            return (
                                                <div className="col-md-4 input_name">
                                                    <BuyerSidebar />
                                                </div>
                                            )
                                        } else if (this.state.type == 2) {
                                            return (
                                                <div className="col-md-4 input_name">
                                                    <SideBar />
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div className="col-md-4 input_name">
                                                    <AffiliatorSidebar />
                                                </div>
                                            )
                                        }
                                    })()}

                                    <div className="col-md-8">
                                        <div className=" row">
                                            <div className="col-md-10" style={{ paddingLeft: "22px" }}>
                                                <div className=" mb-1 input_name big_font text-left" style={{ width: '100%' }}>
                                                    {this.props.t('BUYER_ADMIN_MESSAGE.BUYER_ADMIN_MESSAGE_TITLE')}
                                                </div>
                                            </div>
                                            {this.messageList()}
                                            {/* <div className="col-md-2" style={{ marginTop: '66px', paddingLeft: '33px' }} >
                                            <Link to={'/seller-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                                                <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                                            </Link>
                                        </div> */}
                                        </div>
                                        <div className="m-2" style={{ height: "auto !important", borderRadius: '5px', border: "1px solid #e6e6e6", padding: "3%", minHeight: "110px", overflow: "auto" }}>
                                            <div className="m-2 row">

                                            </div>
                                            {this.state.conversation.map(conv =>
                                                <div className="m-2">
                                                    <div className="row">
                                                        {(() => {
                                                            if (conv.img_sender == '' || conv.img_sender == null) {
                                                                return (
                                                                    <div className="col-md-2 mini_pad">
                                                                        <img src={require("../../assets/images/admin.png")} alt="" className="" alt="" width="70" height="70" />
                                                                    </div>
                                                                )
                                                            } else {
                                                                return (
                                                                    <div className="col-md-2 mini_pad">
                                                                        <img src={Common.baseUrl+conv.img_sender} className=" rounded-circle" alt="" width="70" height="70" /><br />
                                                                    </div>
                                                                )
                                                            }
                                                        })()}
                                                        {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                        <div className="col-md-7 ">
                                                            <div className="message_name_text">
                                                                <span><b>{conv.sender}</b></span><br />
                                                            </div>
                                                            <div className="product_description">
                                                                {/* {renderHTML(conv.content)} */}
                                                                {conv.content.split('\n').map(function (item, key) {
                                                                    return (
                                                                        <span key={key}>
                                                                            {item}
                                                                            <br />
                                                                        </span>
                                                                    )
                                                                })}
                                                            </div>
                                                            {(() => {
                                                                if (conv.file !== '') {
                                                                    return (
                                                                        <div style={{ fontSize: "13px" }}>
                                                                            <a href={conv.attchmnt} target="_blank">{conv.file}</a>
                                                                        </div>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <div></div>
                                                                    )
                                                                }
                                                            })()}
                                                            <div className="message_open_time">
                                                                &nbsp;
                                                        </div>
                                                        </div>
                                                        <div className="col-md-3 message_time">
                                                            {(JSON.stringify(conv.created_at)).substring(1, 11)}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </div>
                                            )}


                                            <div className="m-2">
                                                <div className="row">
                                                    <div className="col-md-2 mini_pad">
                                                        <img src={Common.baseUrl+this.state.userImage} className=" rounded-circle" alt="" width="70" height="70" /><br />
                                                        {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                    </div>
                                                    <div className="col-md-10" style={{ borderRadius: "3px" }}>
                                                        <div className="row row_edit" >
                                                            <div className="col-md-3 message text-center" style={{ borderRadius: "3px", fontSize: '12px' }}>
                                                                <span className=""><b>{this.props.t('BUYER_ADMIN_MESSAGE.MESSAGE_TITLE')}</b></span><br />
                                                            </div>
                                                            <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>

                                                            </div>
                                                        </div>
                                                        <div className="message_form" style={{ borderRadius: "3px", padding: "2%" }}>
                                                            <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                                value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                            </textarea>
                                                            <input style={{ fontSize: "13px" }} type="file" onChange={this.onChangePro.bind(this)}></input>
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="text-center p-3 " >
                                                    <button id="snd_msg" onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg" style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                        <span className="fa fa-check"></span>
                                                        {this.props.t('BUYER_ADMIN_MESSAGE.SUBMIT_BTN')}
                                            </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { SystemChat }
SystemChat = withTranslation('buyer')(SystemChat);
